/** URL query parameter carrying a urlHash key. Shared by every producer and consumer of `?q=`. */
export const QUERY_HASH_PARAM = 'q';

export function readQueryHash(search: string): string | null {
  return new URLSearchParams(search).get(QUERY_HASH_PARAM);
}

export function withQueryHash(url: string, hash: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${new URLSearchParams({ [QUERY_HASH_PARAM]: hash })}`;
}

export function stripQueryHash(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(QUERY_HASH_PARAM);
  const str = params.toString();
  return str ? `?${str}` : '';
}
